import { render, staticRenderFns } from "./TransactionStatus.vue?vue&type=template&id=f57d52f6&scoped=true"
import script from "./TransactionStatus.vue?vue&type=script&lang=js"
export * from "./TransactionStatus.vue?vue&type=script&lang=js"
import style0 from "./TransactionStatus.vue?vue&type=style&index=0&id=f57d52f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57d52f6",
  null
  
)

export default component.exports